import { type FC, memo } from 'react';
import { AutoGrowTextAreaField } from 'AutoGrowTextAreaField';

type TextareaProps = {
    name: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    minRows?: number;
    maxHeight?: 'none' | 32 | 48 | 60 | 80;
};

// NOTE: We use the AutoGrowTextAreaField component instead of the HeroUi Textarea component because
// our use of `important: true` in tailwind.config.js is preventing the HeroUi Textarea component from working correctly.
const TextareaComponent: FC<TextareaProps> = ({ name, label, ...rest }) => (
    <AutoGrowTextAreaField
        name={name}
        label={label}
        wrapperClassName="bg-slate-grey-50 hover:bg-slate-grey-100 rounded-7 p-3"
        className="bg-transparent text-slate-grey focus:outline-none"
        {...rest}
    />
);

export const Textarea = memo(TextareaComponent) as typeof TextareaComponent;
